import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/lib/motion";
import { FAQS } from "@/data/urban";
import { FAQ as TID } from "@/constants/testIds";

export const FAQ = () => {
  return (
    <section className="relative py-24 md:py-36 bg-canvas">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center">
          <Reveal><div className="overline text-ink">FAQ</div></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-[1.05]">
              Questions, answered.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={TID.item(i)}
                className="bg-surface rounded-2xl border border-hairline px-5 sm:px-7 data-[state=open]:border-hairline transition-colors"
              >
                <AccordionTrigger className="text-left font-heading text-base sm:text-lg font-bold text-ink py-5 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink-soft leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
